import { RequestOption } from 'src/app/shared/model/common.model';
import { StayInformedService } from 'src/app/shared/service/stay-informed.service';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EventManagerService } from 'src/app/core/services/event-manager.service';
import { WarningBannerDialogComponent } from 'src/app/shared/components/warning-banner-dialog/warning-banner-dialog.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  // tslint:disable-next-line:use-host-property-decorator
  host: {
    '(window:resize)': 'onWindowResize($event)'
  }
})
export class HomeComponent implements OnInit {
  isShow = true;
  isMobile = false;
  width: number = window.innerWidth;
  mobileWidth = 760;
  userName: string;
  requestOption = new RequestOption();
  listStayInformed: any[] = [];
  page = 0;
  totalPages = 0;
  constructor(
    private eventManager: EventManagerService,
    private dialog: MatDialog,
    private stayInformedService: StayInformedService) { }

  ngOnInit() {
    if (localStorage.getItem(btoa('userName'))) {
      this.userName = decodeURIComponent(escape(atob(localStorage.getItem(btoa('userName')))));
    }
    this.eventManager.subscribe('SHOW_SIDEBAR', (res) => {
      this.isShow = res.data.isShow;
    });
    if (atob(sessionStorage.getItem(btoa('showBanner'))) === 'true' && this.userName) {
      const dialogRef = this.dialog.open(WarningBannerDialogComponent, {
        width: '500px',
        maxHeight: '600px',
        disableClose: true
      });
    }
    this.isMobile = this.width < this.mobileWidth;
    this.getListStayInformed(0);
  }

  onWindowResize(event) {
    this.width = event.target.innerWidth;
    this.isMobile = this.width < this.mobileWidth;
    if (this.width < this.mobileWidth) {
      this.isShow = true;
    }
  }
  goPageRegister() {
    window.open('./request-ge-single-sign');
  }

  windowOpen(url) {
    window.open(url);
  }

  public getListStayInformed(page: number) {
    this.requestOption = new RequestOption();
    this.requestOption.pagingOptions.size = 10;
    this.requestOption.pagingOptions.number = page;
    this.stayInformedService.getData(this.requestOption).subscribe(res => {
      this.listStayInformed = res.data.content;
      this.requestOption.pagingOptions.number = res.data.number;
      this.totalPages = res.data.totalPages;
    });
  }

  public paging(num: any) {
    this.page = num;
    this.getListStayInformed(this.page);
  }

  public counter(i: number) {
    return new Array(i);
  }
}
